import React from "react";
import { useTranslation } from "react-i18next";
import { languages } from "../i18n";

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language;
  return (
    <div className="lang" role="group" aria-label="Language">
      {languages.map((language) => (
        <button
          key={language.code}
          type="button"
          className={`lang__btn${current === language.code ? " is-active" : ""}`}
          aria-pressed={current === language.code}
          title={language.label}
          onClick={() => i18n.changeLanguage(language.code)}
        >
          {language.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
